import * as ActionType from './constants';

export type VpxAction = {
    type: string;
    payload: {} | string;
};

export const searchVpxVpExchangeList = (organizationName, companyName, vpName, ownerName, groupId, codeId, hashtag, country): VpxAction => ({
    type: ActionType.SEARCH_VPX_VP_EXCHANGE_LIST,
    payload: { organizationName, companyName, vpName, ownerName, groupId, codeId, hashtag, country },
});

export const searchVpxVpExchangeListSuccess = (vpxList, totalCount = null, truncated = false): VpxAction => ({
    type: ActionType.SEARCH_VPX_VP_EXCHANGE_LIST_SUCCESS,
    payload: { vpxList, totalCount, truncated },
});

export const searchVpxVpExchangeListFailed = (error: string): VpxAction => ({
    type: ActionType.SEARCH_VPX_VP_EXCHANGE_LIST_FAILED,
    payload: error,
});

export const vpViewUserProfile = (userId): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_USER_PROFILE,
    payload: { userId },
});

export const vpViewUserProfileSuccess = (userPofile): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_USER_PROFILE_SUCCESS,
    payload: { userPofile },
});

/** `failure` is the failed response (`{ status, body }`); `error` its text. */
export const vpViewUserProfileFailed = (error: string, failure = { status: 500 }): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_USER_PROFILE_FAILED,
    payload: error,
    failure,
});

export const syncUserProfileOwnerAvatar = (avatarUrl): VpxAction => ({
    type: ActionType.SYNC_USER_PROFILE_OWNER_AVATAR,
    payload: { avatarUrl },
});

export const vpViewOrganizationProfile = (organizationId): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_ORGANIZATION_PROFILE,
    payload: { organizationId },
});

export const vpViewOrganizationProfileSuccess = (organizationProfile): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_ORGANIZATION_PROFILE_SUCCESS,
    payload: organizationProfile,
});

export const vpViewOrganizationProfileFailed = (error: string): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_ORGANIZATION_PROFILE_FAILED,
    payload: error,
});

export const clearVpProfileError = (): VpxAction => ({
    type: ActionType.CLEAR_VALUE_PROPOSITION_PROFILE_ERROR,
    payload: null,
});

export const acceptToFollow = (vpId): VpxAction => ({
    type: ActionType.ACCEPT_TO_FOLLOW,
    payload: { vpId },
});

export const acceptToFollowSuccess = (vpId): VpxAction => ({
    type: ActionType.ACCEPT_TO_FOLLOW_SUCCESS,
    payload: { vpId },
});

export const acceptToFollowFailed = (error: string): VpxAction => ({
    type: ActionType.ACCEPT_TO_FOLLOW_FAILED,
    payload: error,
});

export const requestToFollow = (vpId): VpxAction => ({
    type: ActionType.REQUEST_TO_FOLLOW,
    payload: { vpId },
});

export const requestToFollowSuccess = (vpId): VpxAction => ({
    type: ActionType.REQUEST_TO_FOLLOW_SUCCESS,
    payload: { vpId },
});

export const requestToFollowFailed = (error: string): VpxAction => ({
    type: ActionType.REQUEST_TO_FOLLOW_FAILED,
    payload: error,
});

export const requestToUnfollow = (vpId): VpxAction => ({
    type: ActionType.REQUEST_TO_UNFOLLOW,
    payload: { vpId },
});

export const requestToUnfollowSuccess = (vpId): VpxAction => ({
    type: ActionType.REQUEST_TO_UNFOLLOW_SUCCESS,
    payload: { vpId },
});

export const requestToUnfollowFailed = (error: string): VpxAction => ({
    type: ActionType.REQUEST_TO_UNFOLLOW_FAILED,
    payload: error,
});

export const loadExternalList = (permissionType): VpxAction => ({
    type: ActionType.LOAD_EXTERNAL_LIST,
    payload: { permissionType },
});

export const loadExternalListSuccess = (extenalList): VpxAction => ({
    type: ActionType.LOAD_EXTERNAL_LIST_SUCCESS,
    payload: { extenalList },
});

export const loadExternalListFailed = (error: string): VpxAction => ({
    type: ActionType.LOAD_EXTERNAL_LIST_FAILED,
    payload: error,
});

export const vpViewUserProfileByShareKey = (shareKey): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_USER_PROFILE_BY_SHARE_KEY,
    payload: { shareKey },
});

export const vpViewUserProfileByShareKeyFullSuccess = (userPofile): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_USER_PROFILE_BY_SHARE_KEY_FULL_SUCCESS,
    payload: { userPofile },
});

export const vpViewUserProfileByShareKeyPreviewSuccess = (preview): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_USER_PROFILE_BY_SHARE_KEY_PREVIEW_SUCCESS,
    payload: { preview },
});

export const vpViewUserProfileByShareKeyFailed = (error: string): VpxAction => ({
    type: ActionType.VALUE_PROPOSITION_VIEW_USER_PROFILE_BY_SHARE_KEY_FAILED,
    payload: error,
});
